import { svc_search, svc_fetchOne, svc_editOne } from "@/services";
import { svc_getShifts } from "@/services/cashcollections";
import { message } from "antd";
import "lodash";
import logger from "@/utils/logger";
import { convertISODateTimeToString } from "@/utils/convertTime";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "cashcollections";


const Model = {
	namespace: "m_CashCollections",
	state: {
		cashcollections: [],
		selectedTransaction: {},
		shiftTimes: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { cashcollections } }) {
			logger(`** CashCollections reducers response ${JSON.stringify(cashcollections)}`, 5);
			return { ...state, cashcollections };
		},
		handleFetchOne(state, { payload: { selectedTransaction } }) {
			logger(`** CashCollections reducers response ${JSON.stringify(selectedTransaction)}`, 5);
			return { ...state, selectedTransaction };
		},
		handleGetShifts(state, { payload: { shiftTimes } }){
			return { ...state, shiftTimes }
		}
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			// console.log("*********************** payload: ", payload)
			let cashcollections = yield call(svc_search, endpointBasePrefix, payload);
			_.forEach(cashcollections, function (row) {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["account_closed_timestamp"], "hh:mm:ss A");
				row.disableCancel = row.event_type != 30
			});
			// console.log("*********************** cashcollections: ", cashcollections)
			yield put({
				type: "handleFetchAll",
				payload: { cashcollections },
			});
		},
		*update({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*cancel({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, "cashcollections_custom", payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*fetchShifts({ payload }, {call, put }) {
			let shiftTimes = yield call(svc_getShifts, payload);
			yield put({
				type: "handleGetShifts",
				payload: {shiftTimes}
			})
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/salesdata/daily_sales") {
					dispatch({ type: "fetch", payload: query });
				}
			});
		},
	},
};

export default Model;
